import { render } from "./BrandNjuskaloTechnology.vue?vue&type=template&id=4047ce4c"
import script from "./BrandNjuskaloTechnology.vue?vue&type=script&lang=ts"
export * from "./BrandNjuskaloTechnology.vue?vue&type=script&lang=ts"

import "./BrandNjuskaloTechnology.vue?vue&type=style&index=0&id=4047ce4c&lang=scss"
script.render = render

export default script